/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  return async function onChange(next) {
    if (props.onChange && data !== next) {
      props.onChange(next)
    }
  }
}
